import CashSection from "common/CashSection/CashSection";
import Footer from "common/Footer/Footer";
import ImageSection from "common/ImageSection/ImageSection";
import Navbar from "common/Navbar/Navbar";
import Titlebar from "common/Titlebar/Titlebar";

const MultiPageLayout = ({ guestUser, children, clientConfig }) => {
  return (
    <section id="MultiPageLayout">
      <Titlebar guestUser={guestUser} />
      <Navbar
        guestUser={guestUser}
        showNavbarOptionsForGuestUser={
          clientConfig?.showNavbarOptionsForGuestUser === "true"
        }
      />
      {clientConfig?.hideCashSection !== "true" && (
        <CashSection guestUser={guestUser} />
      )}
      <ImageSection guestUser={guestUser} />
      <>{children}</>
      {clientConfig?.hideFooter !== "true" && <Footer />}
    </section>
  );
};

export default MultiPageLayout;
